import React, {useState} from "react";
import {Box, Button, Grid, InputLabel, Snackbar, TextareaAutosize} from "@material-ui/core";
import Spinner from "../../components/Spinner";
import axiosInstance from "../../api";
import {Alert} from "@material-ui/lab";
import {MUITextareaAutosize} from "../../utils/formUtils";
import {useForm} from "react-hook-form";

export default function CreateCommentTile({agentId, onCommentSave, leadId}) {
    const [comment, setComment] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false);
    const [snackBarSettings, setSnackBarSettings] = useState({show:false, message:null, variant:'success'});
    const {handleSubmit, control, formState: {errors}} = useForm({});


    const handleSaveComment = () => {
        if (comment === undefined || comment === null || comment.trim() === '') {
            setSnackBarSettings({show:true, message:'Please enter notes.', variant:'error'})
            return;
        }
        setSnackBarSettings({show:false, message:null, variant:''});
        setShowSpinner(true);
        axiosInstance.post('agents/saveComment', {agentId:agentId, comment:comment, leadId: leadId})
            .then((data) => {
                setSnackBarSettings({show:true, message:'Comment saved!', variant:'success'});
                onCommentSave();
            })
            .catch((error) => setSnackBarSettings({show:true, message:'An error occurred. Please try again later.', variant:'error'}))
            .finally(() => setShowSpinner(false))
    };

    const handleSnackBarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarSettings({show:false, message:null, variant:''});
    };


    if (showSpinner) return <Spinner/>
    return (
        <>
            <Grid container alignItems="flex-start" spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <InputLabel htmlFor="notes">Notes</InputLabel>
                    {/*<TextareaAutosize*/}
                    {/*    aria-label="Comments"*/}
                    {/*    minRows={4} onChange={(e) => {*/}
                    {/*        console.error(e.target.value);*/}
                    {/*        setComment(e.target.value);}}*/}
                    {/*    style={{width: 600, maxWidth: '95%'}} placeholder="Notes"*/}
                    {/*    name="notes" label="Notes"*/}
                    {/*/>*/}
                    <MUITextareaAutosize control={control} errors={errors} id="notes" minRows={4}
                                         style={{width: 600, maxWidth: '95%'}} placeholder="Notes"
                                         name="notes" label="Notes" onInputChange={ (e) => {
                            setComment(e.target.value);}
                    }/>

                    <Box component="span" justifyContent="flex-start" alignItems="flex-start"
                         display="flex">
                        <Button variant="contained" color="primary" name="btnSubmit" onClick={handleSaveComment}>
                            Save Note
                        </Button>
                    </Box>
                </Grid>
            </Grid>
            <Snackbar open={snackBarSettings.show} autoHideDuration={6000} onClose={handleSnackBarClose}>
                <Alert variant="filled" onClose={handleSnackBarClose} severity={snackBarSettings.variant}>{snackBarSettings.message}</Alert>
            </Snackbar>
        </>
    );
}
